export const API_ENDPOINTS = {
  courier_filters: '/courier/service-level/filters',
  courier_service: '/courier/service-level'
} as const;

export interface ApiResponse<T> {
  code: number;
  transactionId: string;
  message: T;
}

export interface CourierFiltersPayload {
  logisticOperators: string[];
  couriers: string[];
  shippingType: string[];
  deliveryType: string[];
  regions: string[];
  communes: string[];
  timeRange: 'today' | 'week' | 'month' | 'year' | { from: string; to: string };
}

export interface MetricData {
  totalOrders: number;
  deliveryRate: number;                 // % Efectividad Global
  firstAttemptDeliveryRate: number;     // % Efectividad 1ra Visita
  onTimeDeliveryRate: number;           // % Cumplimiento Entrega
  multipleAttemptsDeliveryRate: number;
  minDeliveryAttempts: number;
  maxDeliveryAttempts: number;
  avgDeliveryAttempts: number;
}

export interface BreakdownItem extends MetricData {
  id: string;
}

export interface CourierData extends MetricData {
  id: string;
  regions: BreakdownItem[];
  communes: BreakdownItem[];
}

export interface CourierServiceResponse {
  globalStatistics: any;
  totals: MetricData;
  couriers: CourierData[];
}